/**
 * Resolve the single user whose department and rank permissions must scope the
 * C-Card imputation catalog. An ambiguous shared card must never fall back to
 * tenant-wide categories because that could expose accounting codes that the
 * actual cardholder cannot use.
 */
export function resolveCcardReviewPrincipal({ statementOwnerId, ownerIds = [], currentUserId } = {}) {
    if (statementOwnerId) {
        return { status: 'resolved', reviewForUserId: String(statementOwnerId) };
    }

    const normalizedOwnerIds = ownerIds.map(String).filter(Boolean);
    if (normalizedOwnerIds.length === 1) {
        return { status: 'resolved', reviewForUserId: normalizedOwnerIds[0] };
    }

    const normalizedCurrentUserId = currentUserId ? String(currentUserId) : null;
    if (normalizedCurrentUserId && normalizedOwnerIds.includes(normalizedCurrentUserId)) {
        return { status: 'resolved', reviewForUserId: normalizedCurrentUserId };
    }

    return { status: 'ambiguous', reviewForUserId: null };
}
